import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { NOT_APPLICABLE, OFFICE_HEADERS } from '../../constants'
import { OfficeListingProps } from '../../interfaceTypes/props'
import { CustomTableCell } from '../common/CustomTableCell'
import { StickyTable } from '../common/StickyTable'
import OfficeMenu from '../menus/Office'
import { TableSkeleton } from '../skeletons/TableSkeleton'

const OfficeListing = ({ offices, loading, refetch }: OfficeListingProps) => {
  return (
    <>
      <StickyTable height="300px">
        <TableHead>
          <TableRow hover>
            {OFFICE_HEADERS.map((columnName, index) => {
              return (
                <TableCell key={index} component="th" align={columnName === 'Active Location' ? 'center' : 'left'}>
                  {columnName}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>

        {loading ? (
          <TableSkeleton noOfRows={7} noOfCols={OFFICE_HEADERS.length} />
        ) : (
          <TableBody>
            {offices?.map(office => {
              const { addresses } = office || {}
              const fullAddress =
                addresses?.length &&
                `${addresses[0]!.address1 || ''}, ${addresses[0]!.address2 || ''}, ${addresses[0]!.city || ''} ${
                  addresses[0]!.state || ''
                } ${addresses[0]!.country || ''} ${addresses[0]!.zipCode?.padStart(5, '0') || ''}`

              return (
                <TableRow key={office.id} hover>
                  <CustomTableCell value={office?.officeNumber || NOT_APPLICABLE} maxWidth="376px" />
                  <CustomTableCell value={office.name} maxWidth="376px" />

                  <CustomTableCell value={office?.phone || NOT_APPLICABLE} />
                  {office.addresses && office?.addresses?.length > 0 ? (
                    <CustomTableCell value={fullAddress || NOT_APPLICABLE} />
                  ) : (
                    <CustomTableCell value={NOT_APPLICABLE} />
                  )}
                  <CustomTableCell value={!!office.isLocationOpen} maxWidth="376px" />

                  <TableCell>
                    <OfficeMenu office={office} refetch={refetch} />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        )}
      </StickyTable>
    </>
  )
}

export default OfficeListing
